export const ekadasi = [
    "Utpanna",
    "Moksada",
    "Saphala",
    "Putrada",
    "Sat-tila",
    "Bhaimi",
    "Vijaya",
    "Amalaki vrata",
    "Papamocani",
    "Kamada",
    "Varuthini",
    "Mohini",
    "Apara",
    "Pandava Nirjala",
    "Yogini",
    "Sayana",
    "Kamika",
    "Pavitraropana",
    "Annada",
    "Parsva",
    "Indira",
    "Pasankusa",
    "Rama",
    "Utthana",
    "Parama",
    "Padmini"
]
